module.exports = __webpack_public_path__ + "static/img/water.bac01f3c.png";